import Api from './baseApi';

export default {
  searchRichOrders: (searchDto) => {
    return Api.post('/api/RichOrders/search', searchDto);
  },

  lockOrder: (orderNumber) => {
    return Api.post(`/api/RichOrders/lock/${orderNumber}`);
  },

  unlockOrder: (orderNumber) => {
    return Api.post(`/api/RichOrders/unlock/${orderNumber}`);
  },

  getActivePartnerBanks: () => {
    return Api.get('/api/partnerbanks/all');
  },

  updateOrderStatus: (orderId, status) => {
    return Api.post(`/api/RichOrders/updateStatus/${orderId}`, { status });
  },

  completeBulkOrder: (poolOrders) => {
    // E-Altın için özel endpoint (CompletedDate + Banka altın düşme)
    return Api.post('/api/RichOrders/bulkInsertForEAltin', poolOrders);
  },

  updateOrderItemIban: (orderItemId, newIban) => {
    return Api.post(`/api/RichOrders/updateOrderItemIban/${orderItemId}`, {
      newIban,
    });
  },

  updateOrderItemNotes: (orderItemId, notes) => {
    return Api.post(`/api/RichOrders/updateOrderItemNotes/${orderItemId}`, {
      notes,
    });
  },

  getFraudOrders: () => {
    return Api.get('/api/RichOrders/fraud-orders');
  },

  markFraudSent: (orderNumbers) => {
    return Api.post('/api/RichOrders/mark-fraud-sent', { orderNumbers });
  },

  clearFraudFlag: (orderNumber) => {
    return Api.post(`/api/RichOrders/clear-fraud-flag/${orderNumber}`);
  },

  getCompletedOrdersForExport: (startDate, endDate) => {
    return Api.get('/api/RichOrders/completed-orders-export', {
      params: { startDate, endDate },
    });
  },

  getNewOrdersBankSummary: (startDate, endDate) => {
    return Api.get('/api/RichOrders/new-orders-bank-summary', {
      params: { startDate, endDate },
    });
  },

  getCompletedOrdersBankSummary: (date) => {
    return Api.get('/api/RichOrders/completed-orders-bank-summary', {
      params: { date },
    });
  },
};
